// import MainHeroBanner from "../../../assets/images/comman/banner.png";
import GameHistoryBox from "../../../components/GameBoard/GameHistoryBox";
import { useQuery } from "@tanstack/react-query";
import { getCompletedGamesAPI } from "../../../api/game";
import Loader from "../../../components/Loader/Loader";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import GreenBtn from "../../../components/button/SecondaryBtn";
import CmsBanner from "../../../components/Banner/CmsBanner";
// import GreenBtn from "../../../components/button/GreenBtn";
// import RedBtn from "../../../components/button/RedBtn";

const GameHistory = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { t } = useTranslation();
  const perPage = 10;
  const {
    data: completedGames,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["completedGames"],
    queryFn: () => getCompletedGamesAPI(currentPage, perPage),
  });

  const pagination = completedGames?.data?.pagination;

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="wrapper">
        <CmsBanner
          title={t("gameHistory.title")}
          description={t("gameHistory.description")}
          classNameShape="hidden"

        />
        <section className="2xl:py-[3.5vw] lg:py-15 py-10">
          <div className="w-full 2xl:max-w-[71.667vw] max-w-[86rem] mx-auto 2xl:px-[0.833vw] xl:px-10 px-4">
            <div className="flex flex-wrap justify-center 2xl:gap-[1.25vw] md:gap-6 gap-3">
              {completedGames?.data?.games?.length > 0 ? (
                completedGames.data.games.map((game: any) => (
                  <div key={game._id} className="w-full xs:w-[calc(50%-0.375rem)] sm:w-[calc(33.333%-1rem)] lg:w-[calc(25%-1.125rem)] 2xl:w-[calc(25%-0.9375vw)] flex">
                    <GameHistoryBox
                      gameId={game._id}
                      title={game.game_name}
                      time={new Date(game.created_at).toLocaleDateString("en-US", {
                        day: "2-digit",
                        month: "short",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                      teams={game.teams}
                    />
                  </div>
                ))
              ) : (
                <div className="w-full text-center py-10">
                  <div className="flex flex-col items-center justify-center ">
                    <h2 className="text-2xl font-bold">{t("gameHistory.noGamesFound")}</h2>
                    <GreenBtn to="/create-game" className="mt-4 !mb-0">
                      {t("gameList.createNewGame")}
                    </GreenBtn>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default GameHistory;
